// extracted by mini-css-extract-plugin
export default {"main":"AdminSetupPage_main__53Ea4","root":"AdminSetupPage_root__oYw0n"};